import { render, staticRenderFns } from "./RenewalsLayout.vue?vue&type=template&id=64099b3f&scoped=true&"
import script from "./RenewalsLayout.vue?vue&type=script&lang=js&"
export * from "./RenewalsLayout.vue?vue&type=script&lang=js&"
import style0 from "./RenewalsLayout.vue?vue&type=style&index=0&id=64099b3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64099b3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VIcon,VTab,VTabs})
